import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SwiperModule } from 'swiper/angular';
import { NgChartsModule } from 'ng2-charts';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import {NgxPaginationModule} from 'ngx-pagination';
import { SharedModule } from './shared/shared.module';
// import { FileTransfer, FileUploadOptions, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
// import { File } from '@awesome-cordova-plugins/file/ngx';
import { IonCustomScrollbarModule } from 'ion-custom-scrollbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PpAssignListComponent } from './pp/add-pp/pp-assign-list/pp-assign-list.component';
import { PpAssignAddComponent } from './pp/add-pp/pp-assign-add/pp-assign-add.component';
import { PpAssignDetailComponent } from './pp/add-pp/pp-assign-detail/pp-assign-detail.component';
import { ListPpComponent } from './pp/assign-pp/list-pp/list-pp.component';
import { DetailPpComponent } from './pp/assign-pp/detail-pp/detail-pp.component';
import { AddPpComponent } from './pp/assign-pp/add-pp/add-pp.component';
import { ValidasiPpComponent } from './pp/validasi-pp/validasi-pp/validasi-pp.component';
import { ValidasiPpDetailComponent } from './pp/validasi-pp/validasi-pp-detail/validasi-pp-detail.component';
import { AssignSurveyorComponent } from './assign/assign-surveyor/assign-surveyor.component';
import { AssignSurveyorDetailComponent } from './assign/assign-surveyor-detail/assign-surveyor-detail.component';
import { DelegasiListComponent } from './delegasi/delegasi-list/delegasi-list.component';
import { DelegasiModalSubmitComponent } from './delegasi/delegasi-modal-submit/delegasi-modal-submit.component';
import { ReportNasabahComponent } from './report/sales-report/report-nasabah/report-nasabah.component';
import { HasilSurveyComponent } from './report/surveyor-report/hasil-survey/hasil-survey.component';
import { DetailHasilSurveyComponent } from './report/surveyor-report/detail-hasil-survey/detail-hasil-survey.component';
import { DetailReportNasabahComponent } from './report/sales-report/detail-report-nasabah/detail-report-nasabah.component';
import { DetailReportPerformanceComponent } from './report/sales-report/detail-report-performance/detail-report-performance.component';
import { ReportPerformanceComponent } from './report/sales-report/report-performance/report-performance.component';
import { ReportPerformanceColComponent } from './report/collector-report/report-performance-col/report-performance-col.component';
import { DetailPerformanceColComponent } from './report/collector-report/detail-performance-col/detail-performance-col.component'
// import { CKEditorModule } from 'ng2-ckeditor';
// import { EditorModule } from '@tinymce/tinymce-angular';
// import { QuillModule } from 'ngx-quill';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
// import { ClassicEditor } from '@ckeditor/ckeditor5-build-classic';
// import { NgxQuillModule } from '@dimpu/ngx-quill';
// import { NgxEditorModule } from 'ngx-editor';
// import {MatCheckboxModule} from '@angular/material/checkbox';
// import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
    declarations: [
        AppComponent,
        // PpAddComponent,
        PpAssignListComponent,
        PpAssignAddComponent,
        PpAssignDetailComponent,
        ListPpComponent,
        DetailPpComponent,
        AddPpComponent,
        ValidasiPpComponent,
        ValidasiPpDetailComponent,
        AssignSurveyorComponent,
        AssignSurveyorDetailComponent,
        DelegasiListComponent,
        DelegasiModalSubmitComponent,
        ReportNasabahComponent,
        HasilSurveyComponent,
        DetailHasilSurveyComponent,
        DetailReportNasabahComponent,
        DetailReportPerformanceComponent,
        ReportPerformanceComponent,
        ReportPerformanceColComponent,
        DetailPerformanceColComponent,
    ],
    exports : [
        // PpAddComponent,
        PpAssignListComponent,
        PpAssignAddComponent,
        PpAssignDetailComponent,
        ListPpComponent,
        DetailPpComponent,
        AddPpComponent,
        ValidasiPpComponent,
        ValidasiPpDetailComponent,
        AssignSurveyorComponent,
        AssignSurveyorDetailComponent,
        DelegasiListComponent,
        DelegasiModalSubmitComponent
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        SwiperModule,
        HttpClientModule,
        IonCustomScrollbarModule,
        FormsModule,
        NgChartsModule,
        NgxPaginationModule,
        BrowserAnimationsModule,
        SharedModule,
        ReactiveFormsModule
        // MatCheckboxModule,
        // MatExpansionModule,
        // NgxEditorModule
        // EditorModule
        // CKEditorModule,
        // QuillModule
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        // File,
        // FileTransfer,
        // FileTransferObject,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
